import {Button, Loading} from "../../../components";
import ActionBar from "../../../layout/ActionBar";
import * as Yup from "yup";
import {Controller, useForm} from "react-hook-form";
import {
    CheckBoxField,
    DateField,
    EditorField, GroupCheckBoxField,
    InputField,
    SelectField
} from "../../../components/Forms";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {Col, Row} from "antd";
import {
    apiError,
    handleRequest,
    strToTime
} from "../../../utils";
import {promotionApi} from "../../../api";
import {globalNavigate} from "../../../routes/GlobalHistory";

function PromotionAdd()
{
    const typeOptions = [
        {value: 'all', label: "Nhiều loại"},
        {value: 'marketing', label: "Marketing"},
        {value: 'website', label: "Website"},
        {value: 'host', label: "Host"},
        {value: 'ssl', label: "SSL"},
        {value: 'email', label: "Email server"},
    ]

    const showOptions = [
        {value: 1, label: "Kinh doanh Sikido"},
        {value: 2, label: "Kinh doanh D&H"},
        {value: 3, label: "Kinh doanh Fast Digital"},
        {value: 4, label: "Khách hàng"},
    ]

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Bạn chưa điền tên chương trình'),
        content: Yup.string().required('Bạn chưa điền chi tiết chương trình'),
        timeStart: Yup.string().required('Bạn chưa chọn ngày bắt đầu chạy chương trình'),
        timeEnd: Yup.string().required('Bạn chưa chọn ngày kết thúc chương trình'),
        type: Yup.string().required('Bạn chưa chọn loại khuyến mãi'),
        show: Yup.array().required('Bạn chưa chọn đối tượng hiển thị khuyến mãi'),
    })

    const initialValues = {
        name: '',
        content: '',
        timeStart: new Date(),
        timeEnd: new Date(),
        type: 'all',
        show: 'all',
    }

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validationSchema)
    });


    const eventHandlers = {
        submit: async (data) => {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('content', data.content);
            formData.append('type', data.type);
            data.show.forEach(value => {
                formData.append('show[]', value);
            });
            formData.append('timeStart', strToTime(data.timeStart));
            formData.append('timeEnd', strToTime(data.timeEnd));
            if (data.file) formData.append('file', data.file);

            let [error, response] = await handleRequest(promotionApi.add(formData));

            let message = apiError(`Thêm chương trình khuyến mãi thất bại`, error, response);

            if (!message) {
                globalNavigate("/promotion");
            }
        },
    }

    return (
        <>
            <ActionBar title={'Thêm chương trình khuyến mãi'}>
            </ActionBar>
            <div className="container">
                <div className="content pd-3" style={{overflow: 'auto'}}>
                    <form className="form mt-3 mb-3" onSubmit={handleSubmit(eventHandlers.submit)}>
                        {isSubmitting && <Loading/>}
                        <Row gutter={10}>
                            <Col className="gutter-row" span={12}>
                                <Controller control={control} name="name" render={({ field }) => (
                                    <InputField label="Tên chương trình" errors={errors} {...field}/>
                                )}/>
                                <Controller control={control} name="content" render={({ field }) => (
                                    <EditorField label="Nội dung chương trình" errors={errors} {...field}/>
                                )}/>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <p className="heading">Thông tin</p>
                                <Row gutter={10}>
                                    <Col className="gutter-row" span={8}>
                                        <Controller control={control} name="type" render={({field}) => (
                                            <SelectField label="Loại khuyến mãi" options={typeOptions} errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                    <Col className="gutter-row" span={8}>
                                        <Controller control={control} name="timeStart" render={({field}) => (
                                            <DateField label="Ngày bắt đầu chạy" errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                    <Col className="gutter-row" span={8}>
                                        <Controller control={control} name="timeEnd" render={({ field }) => (
                                            <DateField label="Ngày kết thúc" errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col className="gutter-row" span={24}>
                                        <Controller control={control} name="show" render={({field}) => (
                                            <GroupCheckBoxField label="Chỉ hiển thị cho" options={showOptions} errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                </Row>
                                <Controller control={control} name="file" render={({field}) => (
                                    <InputField
                                        label="Ảnh đại diện"
                                        type="file"
                                        errors={errors}
                                        onChange={(e) => {
                                            field.onChange(e.target.files[0]); // chỉ lấy 1 file
                                        }}
                                    />
                                )}/>
                            </Col>
                        </Row>

                        <hr />
                        <div className="form-group">
                            <Button primary type="submit">Tạo chương trình</Button>
                        </div>
                    </form>
                </div>
            </div>
        </>

    )
}

export default PromotionAdd;